import { render, staticRenderFns } from "./r-exchange-page.vue?vue&type=template&id=10e3e18d"
import script from "./r-exchange-page.vue?vue&type=script&lang=js"
export * from "./r-exchange-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e3e18d')) {
      api.createRecord('10e3e18d', component.options)
    } else {
      api.reload('10e3e18d', component.options)
    }
    module.hot.accept("./r-exchange-page.vue?vue&type=template&id=10e3e18d", function () {
      api.rerender('10e3e18d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/exchange/r-exchange-page.vue"
export default component.exports